/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import CheckInView from '../../view/pages/check_in/CheckInView'
import CheckInAction from '../../action/check_in/index'
import CheckInSearchStore from '../../store/check_in/CheckInSearchStore'
import ReservationAction from '../../action/reservation'
import ReservationsStore from '../../store/reservation/ReservationsStore'
import CheckInPaginationStore from '../../store/check_in/CheckInPaginationStore'
import NProgress from 'nprogress'

class CheckInContainer extends Component {
  static getStores() {
    return [ReservationsStore, CheckInSearchStore, CheckInPaginationStore]
  }

  static calculateState(prevState, props) {
    return {
      reservations: ReservationsStore.getState(),
      search: CheckInSearchStore.getState(),
      pagination: CheckInPaginationStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    await CheckInAction.onSearch(this.state.search, this.state.pagination)
    await ReservationAction.fetchRooms()
    NProgress.done()
  }

  render() {
    return CheckInView(this.state)
  }
}

export default withRouter(Container.create(CheckInContainer, { withProps: true }))
